import { useAuthConfig } from "@theprelude/core";
import {
  Button,
  CopyButton,
  DownloadIcon,
  InputField,
  Input,
  useDownloadFile,
  DialogContent,
  Dialog,
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogFooter,
  DialogClose,
} from "@theprelude/ds";
import { tb } from "@/lib/tracking";

export const ServiceUserModal: React.FC<{
  onClose: () => any;
  token: string;
  name: string;
}> = ({ onClose, token, name }) => {
  const { credentials } = useAuthConfig();

  const generatedRegString = `${credentials?.account}/${token}`;

  const backupString = useDownloadFile({
    filename: "registration-string.txt",
    type: "text/plain",
    description: "Registration string",
    data: generatedRegString,
  });

  return (
    <Dialog
      defaultOpen
      onOpenChange={(value) => {
        if (!value) {
          onClose();
        }
      }}
    >
      <DialogContent className="w-[500px]" disableImplicitClose>
        <DialogHeader>
          <DialogTitle>New service user has been created</DialogTitle>
        </DialogHeader>

        <DialogBody>
          <div className="mb-4 flex flex-col gap-6">
            <p>
              Keep this information somewhere safe but accessible if you&rsquo;d
              like to associate more probes with this service user in the
              future.
            </p>

            <InputField label="Service User">
              <Input readOnly value={name} />
            </InputField>

            <InputField label="Registration String">
              <Input
                readOnly
                after={<CopyButton toCopy={generatedRegString} />}
                value={generatedRegString}
              />
            </InputField>
          </div>
        </DialogBody>

        <DialogFooter>
          <Button
            intent="caution"
            className={tb("export-credentials")}
            onClick={backupString.execute}
            icon={<DownloadIcon />}
          >
            Backup Registration String
          </Button>

          <DialogClose asChild>
            <Button intent="secondary" className={tb("got-it")}>
              Got it
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
